import { Spinner } from '@/components';

export function PipLoadingState() {
    return (
        <div className="flex items-center justify-center w-full h-full bg-black-100 rounded-[2px]">
            <Spinner />
        </div>
    );
}
